import { render, staticRenderFns } from "./brand-card.vue?vue&type=template&id=57382053&scoped=true&"
import script from "./brand-card.vue?vue&type=script&lang=js&"
export * from "./brand-card.vue?vue&type=script&lang=js&"
import style0 from "./brand-card.vue?vue&type=style&index=0&id=57382053&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57382053",
  null
  
)

export default component.exports